import * as Yup from "yup";
import { DELIVERY_TYPES } from "constants";

const pickUpLocationSchema = Yup.object().shape({
  pickupSlotFrom: Yup.date()
    .transform((value, originalValue) => {
      // Handle empty or invalid date strings gracefully
      return originalValue ? new Date(originalValue) : null;
    })
    .when("deliveryType", {
      is: DELIVERY_TYPES?.jots,
      then: (schema) =>
        schema
          .typeError("Please enter a valid Pick-up From date and time")
          .required("Please enter Pick-up slot: From field")
          .min(
            new Date(),
            "Pick-up From time must be current date & time or later",
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  pickupSlotTo: Yup.date()
    .transform((value, originalValue) => {
      return originalValue ? new Date(originalValue) : null;
    })
    .when(["deliveryType", "pickupSlotFrom"], {
      is: (deliveryType) => deliveryType === DELIVERY_TYPES?.jots,
      then: (schema) =>
        schema
          .typeError("Please enter a valid Pick-up To date and time")
          .required("Please enter Pick-up slot: To field")
          .min(
            Yup.ref("pickupSlotFrom"),
            "Pick-up To time must be equal or after From time",
          ),
      otherwise: (schema) => schema.notRequired(),
    }),

  pickUpLocation: Yup.string().when("deliveryType", {
    is: (deliveryType) =>
      deliveryType === DELIVERY_TYPES?.jots ||
      deliveryType === DELIVERY_TYPES?.sellerDelivery,
    then: (schema) => schema.required("Seller address is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export default pickUpLocationSchema;
